import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SendCommandDto } from 'src/app/model/qModel.model';
import { ApiService } from 'src/app/services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
@Component({
  selector: 'app-anti-theft',
  templateUrl: './anti-theft.component.html',
})
export class AntiTheftComponent implements OnInit {
  antitheftData: any[] = [];
  deviceId: string = '';
  isLoading: boolean = false;
  tabsData: any = [];

  selectedI: number = 0
  getRequestType: string = 'PHOTO';
  sendCommanddto: SendCommandDto = new SendCommandDto();
  restorePublishForm: FormGroup = new FormGroup({
    mobileDeviceName: new FormControl('')
  })
  mobileDevice: any = [];
  isPremium: boolean = false;
  errorMessage: string = ''

  constructor(private _formBuilder: FormBuilder, private _Service: ApiService, private translateService: TranslateService, private _activatedRoute: ActivatedRoute, private _toastr: ToastrService, private _router: Router, private location: Location) {
    let tabsData = [];
    translateService.get(["SETTINGS"]).subscribe(
      values => {
        tabsData = Object.keys(values).map(key => values[key]);
        this.tabsData = tabsData[0].ANTITHEFT_TABS;
      }
    );
  }
  autoDialForm: FormGroup = new FormGroup({
    mobileNo: new FormControl('')
  });
  autoDialNo: any;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];

  ngOnInit(): void {
    this.deviceId = this._activatedRoute.snapshot.params["id"];

    this.getAntitheftCommandData(this.getRequestType)
    this.getDevicesInUser();
    this.autoDialForm = this._formBuilder.group(
      {
        mobileNo: ['']
      },
    );
  }

  goBack() {
    this.location.back()
  }
  selectedIndex(i: any, data: any) {
    this.selectedI = i;
    this.getRequestType = data.requestType;
    this.errorMessage = '';
    this.getAntitheftCommandData(this.getRequestType)
  }


  // Fetching the data for the antitheft
  getAntitheftCommandData(requestType: any) {
    this.isLoading = true;
    this._Service.getService(this._Service.API_URL.getAntitheftCommandData + this.deviceId + '?requestType=' + requestType).subscribe((response) => {
      if (response && response.status.code === 200) {
        this.isLoading = false;
        this.antitheftData = response.data;
      }
      this.isLoading = false;
    })
  }
  mobileNoWrong: boolean = false;
  onFocusOutMobile(event: any) {

    if (event && event.number?.length < 8) {
      this.mobileNoWrong = true;
    } else {
      this.mobileNoWrong = false;
    }
  }
  get f(): { [key: string]: AbstractControl } {
    return this.autoDialForm.controls;
  }
  removeSpace(event: any) {
    if (event.code === "Space") {
      event.preventDefault()

    }
  }
  // Send Command
  sendCommand() {
    this.isLoading = true;
    try {
      this.sendCommanddto.mobileNo = this.autoDialForm.controls['mobileNo'].value.number;
      this.sendCommanddto.deviceId = this.deviceId;
      this.sendCommanddto.requestType = this.getRequestType;
      this._Service.postService(this._Service.API_URL.sendCommand, this.sendCommanddto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this._toastr.success('', response.status.message);
        } else {
          this._toastr.error('', response.status.message);
          this.isLoading = false;
        }
        this.isLoading = false;
      })
    } catch (error) {
      this.isLoading = false;
    }
  }

  // Fethcing the Device Details here
  getDevicesInUser() {
    this.isLoading = true;
    try {
      this._Service.getService(this._Service.API_URL.getPremiumDeviceInUser).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.mobileDevice = response.data;
          if (this.deviceId) {
            this.mobileDevice.forEach((element: any) => {

              if (this.deviceId == element.id) {
                this.isPremium = element.isPremium;
                let isAutoDialAllowed = element.isAutoDialAllowed;

                if (isAutoDialAllowed) {
                  this.tabsData.forEach((ele: any) => {
                    if (ele.requestType === 'CALL') {
                      ele.isAutoDialAllowed = false;
                    }
                  })
                }

                this.restorePublishForm.controls['mobileDeviceName'].setValue(element.id);
              }
            });
          } else {
            this.isPremium = response.data[0].isPremium;
            let deviceId = response.data[0].id;
            let isAutoDialAllowed = response.data[0].isAutoDialAllowed;

            if (isAutoDialAllowed) {
              this.tabsData.forEach((ele: any) => {
                if (ele.requestType === 'CALL') {
                  ele.isAutoDialAllowed = false;
                }
              })
            }
            this.restorePublishForm.controls['mobileDeviceName'].setValue(deviceId);
          }
        } else {
          this.isLoading = false;
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }

  onMobileDeviceSelect(event: any) {
    this.deviceId = event.target.value;
    let isAutoDialAllowed: boolean = false;
    this.mobileDevice.forEach((element: any) => {
      if (element.id === this.deviceId) {
        isAutoDialAllowed = element.isAutoDialAllowed;
      }
    });

    this.tabsData.forEach((element: any) => {

      if (element.requestType === 'CALL') {

        if (isAutoDialAllowed) {

          element.isAutoDialAllowed = false;

        } else {
          element.isAutoDialAllowed = true;
          this.selectedI = 0;
        }

      }
    });


  }

  onSubmit() {
    this.sendCommand()
  }

}
